import React from 'react';
import { RefreshCw, DollarSign } from 'lucide-react';
import { Button } from '../ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import HamburgerMenu from './HamburgerMenu';
import WebhookInfoButton from './WebhookInfoButton';

const GHL_CUSTOM_VALUES_URL =
  'https://app.leadseverywhere.net/v2/location/2llwOnTMGXnzyMKidM7j/settings/custom_values';

export default function TopBar({ onRefresh, billingRate }) {
  const formattedRate = billingRate != null
    ? `$${Number(billingRate).toFixed(2)}/hr`
    : '…';

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
        <h1 className="text-lg font-semibold tracking-tight" data-role="heading">
          Pending Service Invoices
        </h1>

        <div className="flex items-center gap-2">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <a
                  href={GHL_CUSTOM_VALUES_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-md bg-muted hover:bg-muted/80 transition-colors duration-150 cursor-pointer"
                  data-testid="billing-rate-display"
                >
                  <DollarSign className="h-3.5 w-3.5 text-primary" />
                  <span data-role="mono">{formattedRate}</span>
                </a>
              </TooltipTrigger>
              <TooltipContent>Click to update billing rate in GHL</TooltipContent>
            </Tooltip>
          </TooltipProvider>

          <WebhookInfoButton />

          <Button
            variant="ghost"
            size="sm"
            onClick={onRefresh}
            className="text-muted-foreground hover:text-foreground transition-colors duration-150"
            data-testid="refresh-button"
          >
            <RefreshCw className="h-4 w-4" />
          </Button>

          <HamburgerMenu />
        </div>
      </div>
    </header>
  );
}
